module.exports = __webpack_public_path__ + "static/media/gifts.ee3a38d0.svg";